var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#434343;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.9,158.2c1.2,0,2.4-0.4,3.2-1.3c1.7-1.7,1.7-4.6,0-6.4L79.4,100l50.7-50.5c1.7-1.7,1.7-4.6,0-6.4 c-1.7-1.8-4.6-1.7-6.4,0L69.9,96.8c-0.8,0.8-1.3,2-1.3,3.2s0.5,2.4,1.3,3.2l53.8,53.7C124.6,157.8,125.7,158.2,126.9,158.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.cb7fabae68f5ee6789675f27a0b0390b.svg";
export { ForwardRef as ReactComponent };